import React, { useEffect, useRef, useState } from 'react';
import '../styles/ProjectReferences.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ReferenceImage from '../website_images/Fotos/reference-header.png';
import PropertyImage from '../website_images/Fotos/image_slider.png';
import ScrollAnimation from '../components/ScrollAnimation';
import ProjectKOPhoto from '../website_images/Fotos/projectKO.png'
import ProjectJEPhoto from '../website_images/Fotos/projectJE.png'
import ProjectMB91Photo from '../website_images/Fotos/projectMB91.png'

const ProjectReferences: React.FC = () => {
    const { t } = useTranslation();
    const [currentSlide, setCurrentSlide] = useState(0);

    const tileSets = [
        {
            id: 1,
            title: t('projectSM5Title'),
            subtitle: t('projectSM5Subtitle'),
            description: t('projectSM5Description'),
            additionalInformation: t('projectSM5AdditionalInfo'),
            buttonText: t('projRefComplProjButton'),
            backgroundImage: ReferenceImage,
            navigation: "/project-sm"
        },
        {
            id: 2,
            title: t('projectTU33Title'),
            subtitle: t('projectTU33Subtitle'),
            description: t('projectTU33Description'),
            additionalInformation: t('projectTU33AdditionalInfo'),
            buttonText: t('projRefComplProjButton'),
            backgroundImage: PropertyImage,
            navigation: "/project-tu"
        },
        {
            id: 3,
            title: t('projectKOrefTitle'),
            subtitle: t('projectKOrefSubtitle'),
            description: t('projectKOrefDescription'),
            additionalInformation: t('projectKOrefAdditionalInfo'),
            buttonText: t('projRefComplProjButton'),
            backgroundImage: ProjectKOPhoto,
            navigation: "/project-ko"
        },
        {
            id: 4,
            title: t('projectJErefTitle'),
            subtitle: t('projectJErefSubtitle'),
            description: t('projectJErefDescription'),
            additionalInformation: t('projectJErefAdditionalInfo'),
            buttonText: t('projRefComplProjButton'),
            backgroundImage: ProjectJEPhoto,
            navigation: "/project-je"
        },
        {
            id: 5,
            title: t('projectMB91refTitle'),
            subtitle: t('projectMB91refSubtitle'),
            description: t('projectMB91refDescription'),
            additionalInformation: t('projectMB91refAdditionalInfo'),
            buttonText: t('projRefComplProjButton'),
            backgroundImage: ProjectMB91Photo,
            navigation: "/project-mb91"
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % tileSets.length);
        }, 8000);
        return () => clearInterval(timer);
    }, [tileSets.length]);

    return (
        <div className='container'>
            <section className='references-header-section page-hero' id="page-hero"> </section>
            <section className='main-section' id="investment-chances">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <h1>{t('projRefBelowHeroH1')}</h1>
                    <h2>{t('projRefBelowHeroH2')}</h2>
                    <p>{t('projRefBelowHeroP')}</p>
                </ScrollAnimation>
            </section>
            <section className="hero-section section-investmentProducts">
                <div className='slider-section references-slider-section'>
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <h1 id="investment-options">{t('projRefCurrentProjH1')}</h1>
                    </ScrollAnimation>
                    <section className="hero-section">
                        <div className="process-section-references">
                            <div className="container">
                                <div className="process-tiles-references">
                                    {tileSets.map((step, index) => (
                                        <ScrollAnimation animation="fadeInUp" delay={index * 0.1}>
                                            <div
                                                key={step.id}
                                                className="process-tile-references"
                                                style={{ backgroundImage: `url(${step.backgroundImage})` }}
                                            >

                                                <div className="tile-gradient-overlay"></div>
                                                <div className="tile-content-references">
                                                    <div className='references-description'>
                                                        <h3 className="tile-title-references">{step.title}</h3>
                                                        <h4 className="tile-subtitle-references">{step.subtitle}</h4>
                                                        <p className='tile-description-references'>{step.description}</p>
                                                        <div className="additional-information-references">
                                                            {step.additionalInformation}
                                                        </div>
                                                    </div>
                                                    <div className='reference-button-container'>
                                                        <Link to={step.navigation} className="tile-button-references">{step.buttonText}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </ScrollAnimation>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {/** 
                <div className='slider-section references-slider-section' id="references">
                    <h1>Erfolgreich umgesetzt</h1>
                    <section className="hero-section">
                        <div className="process-section-references">
                            <div className="container">
                                <div className="process-tiles-references">
                                    {tileSets.map((step, index) => (
                                        <ScrollAnimation animation="fadeInUp" delay={index * 0.1}>
                                            <div
                                                key={step.id}
                                                className="process-tile-references"
                                            >
                                            <div className="tile-content-references">
                                                <div className='references-description'>
                                                    <h3 className="tile-title-references">{step.title}</h3>
                                                    <h4 className="tile-subtitle-references">{step.subtitle}</h4>
                                                    <p className='tile-description-references'>{step.description}</p>
                                                    <div className="additional-information-references">
                                                        {step.additionalInformation}
                                                    </div>
                                                </div>
                                                <div className='reference-button-container'>
                                                    <button className="tile-button-references">Mehr erfahren</button>
                                                </div>
                                            </div>
                                        </div>
                                        </ScrollAnimation>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>*/}
            </section>
            <section className='main-section references-contact'>
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <h1 className="header-contact">{t('projRefPartner?H1')}</h1>
                    <h2>{t('projRefPartner?H2')}</h2>
                    <div className="contact-button-section">
                        <Link to='/kontakt' className="knowhow-button-section">{t('projRefPartnerKontakt')}</Link>
                    </div>
                </ScrollAnimation>
            </section>
        </div>
    );
};

export default ProjectReferences;